<template>
  <div class="marquee-swiper" :style="{
    'background': data.infoItme.bjColor,
    'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`
  }">
    <swiper :options="swiperOptions" ref="mySwiper">
      <swiper-slide v-for="(item, index) in filteredList" :key="index" style="height: 100px;">
        <div class="announcement" :style="{ color: data.color }">
          <i :class="['font-icon', item.icon]"></i>
          <span>{{ item.title }}</span>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'gonggaoView',
  props: {
    data: Object
  },
  data () {
    return {}
  },
  watch: {
    // 监听父组件传入的数据变化
    'data.swiper.list': {
      immediate: true,
      deep: true,
      handler (newValue, oldVal) {
        // 数据变化时执行的操作
        // 强制更新视图
        if (oldVal !== undefined) {
          if (this.$refs.mySwiper.swiper) {
            if (this.$refs.mySwiper.swiper) {
              this.$refs.mySwiper.swiper.update()
              this.$forceUpdate()

              console.log(
                '数据变化了吗',
                this.filteredList,
                this.$refs.mySwiper.swiper
              )
            }
          }
        }
      }
    },
    'data.align': {
      immediate: true,
      deep: true,
      handler (newValue, oldVal) {
        console.log('ahahahh', newValue, this.$refs.mySwiper)
        if (this.$refs.mySwiper) {
          if (newValue === '向上') {
            this.$refs.mySwiper.swiper.changeDirection('vertical')

            // this.$refs.mySwiper.swiper.updateParams({
            //   direction: "vertical"
            // });
          } else {
            this.$refs.mySwiper.swiper.changeDirection('horizontal')
          }
        }
      }
    }
  },
  computed: {
    filteredList () {
      console.log('4444444', this.data.swiper.list)
      return this.data.swiper.list || []
    },
    swiperOptions () {
      console.log('555555')

      return {
        direction: 'vertical',
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: false
      }
    }
  },
  mounted () {
    // 初始化 Swiper
    this.$nextTick(() => {
      console.log('初始化')
      if (this.$refs.mySwiper.swiper) {
        this.$refs.mySwiper.swiper.update()
      }
    })
  }
}
</script>

<style scoped>
.marquee-swiper {
  width: 100%;
  overflow: hidden;
}

.announcement {
  display: flex;
  height: 39px;
  line-height: 39px;
  padding: 0 15px;
  font-size: 14px;
  align-items: center;
}

.swiper-container {
  width: 100%;
  height: 39px;
}

.font-icon {
  font-size: 18px;
  margin-right: 8px;
}
/deep/ .announcement {
  padding: 0;
}

/* /deep/ .swiper-slide {
  height: 39px !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/gonggao/gonggaoPreview.vue